import './delay_render_chart_view.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.CrossDimensionView extends CustomerVisualMode.Charts.DelayRenderChartView
  className: 'grid-item cross-dimension full-width-chart'
  template: JST['backbone/templates/customer_visual_mode/charts/cross_dimension_chart']
  @NAME: 'cross_dimension_chart'

  CHART_TYPE = Common.Dashboard.Widget.ChartType

  initialize: ({widget, chartView, barMenu, sortDropdown, data, session, dataTranslator, dataFormatter, isReadOnly, isResponsive}) ->
    @widget = widget
    @chartView = chartView
    @barMenu = barMenu
    @sortDropdown = sortDropdown
    @data = data
    @session = session
    @dataTranslator = dataTranslator
    @dataFormatter = dataFormatter
    super({widget, title: @_getTitle(), data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @_setChartWidth()
    @listenTo(@chartView, 'crossdimension:click', @_onChartClick)
    @$el.find('.chart').html(@template)
    @$el.find('.cross-dimension-chart').append(@chartView.render().el)
    @$el.find('.chart-actions').prepend(@sortDropdown.render().el) if @sortDropdown
    @$el.find('.chart-actions').children().last().before(@barMenu.render().el)
    @

  toggleShowQuantity: ->
    @widget.set('show_top_ten', !@widget.get('show_top_ten'))
    @widget.updateWidget()
    @_updateChartData()

  toggleMissingValues: =>
    newState = not @widget.get 'show_missing'
    @widget.set 'show_missing', newState
    @widget.updateWidget()
    @_updateChartData()
    @_renderChart()

  _renderChart: ->
    @chart = @chartView.renderChart()
    @_setChartWidth()
    @barMenu.chart = @chart
    @barMenu.chartView = @
    @chart

  _onChartClick: (elementValue) =>

  _setChartWidth: ->
    @chartView.setChartWidth(@)
    @chart?.reflow()

  _changeSorting: (newSortValue) ->
    @widget.set('sorting', newSortValue)
    @widget.updateWidget()
    @_updateChartData()

  toggleMaximize: =>
    @widget.set('is_maximized', !@widget.get('is_maximized'))
    @widget.updateWidget()
    @trigger('masonry')
    @_setChartWidth()

  _getTitle: ->
    return @widget.get('title') unless @widget.canSelectQuantityToShow()
    extra_text = if @widget.get('show_top_ten') && @_totalDataLength() > 10
                   I18n.t('customer_visual_mode.charts.cross_dimension.top_ten')
                 else
                   I18n.t('customer_visual_mode.charts.cross_dimension.all_results')
    "#{@widget.get('title')} (#{extra_text})"

  _updateChartData: ->
    @_updateTitle(@_getTitle())
    @chartView.updateData(@dataFormatter.format(@widget, @data))

  _totalDataLength: ->
    @data.data.length + if @widget.shouldAddMissing(@data) then 1 else 0

  _currentHierarchicalTagCode: ->
    @widget.get('hierarchical_tags_options').code

  _missingValue: ->
    'missing'
